import { inject, InjectionToken } from '@angular/core';
import { FirestoreService } from '../services';
import { Observable } from 'rxjs';

export const FIRESTORE_TOKEN: InjectionToken<FirestoreProvider> = new InjectionToken<FirestoreProvider>(
  'FIRESTORE_TOKEN',
  {
    factory: (): FirestoreProvider => {
      const firestoreService: FirestoreService = inject(FirestoreService);

      return {
        documentSnapshot<T>(collectionPath: string, documentId: string): Observable<T> {
          return firestoreService.documentSnapshot<T>(collectionPath, documentId);
        },
        collectionData<T>(collectionPath: string, options?: { idField?: string }): Observable<T[]> {
          return firestoreService.collectionData<T>(collectionPath, options);
        },
        subcollectionSnapshot<T>(
          parentCollectionPath: string,
          parentDocumentId: string,
          subcollectionPath: string
        ): Observable<T[]> {
          return firestoreService.subcollectionSnapshot<T>(parentCollectionPath, parentDocumentId, subcollectionPath);
        },
        appendToArray<T>(collectionPath: string, documentId: string, field: string, value: T): Promise<void> {
          return firestoreService.appendToArray(collectionPath, documentId, field, value);
        },
        updateDocument(collectionPath: string, documentId: string, data: Record<string, unknown>): Promise<void> {
          return firestoreService.updateDocument(collectionPath, documentId, data);
        }
      };
    }
  }
);

export interface FirestoreProvider {
  documentSnapshot<T>(collectionPath: string, documentId: string): Observable<T>; // AllowToWeb | Intro | Custom Notification
  collectionData<T>(collectionPath: string, options?: { idField?: string }): Observable<T[]>; // FF Manager | FF Service
  subcollectionSnapshot<T>(
    parentCollectionPath: string,
    parentDocumentId: string,
    subcollectionPath: string
  ): Observable<T[]>; // Unread Messages
  appendToArray<T>(collectionPath: string, documentId: string, field: string, value: T): Promise<void>; // Intro
  updateDocument(collectionPath: string, documentId: string, data: Record<string, unknown>): Promise<void>; // FF Manager
}
